<div class="container my-5">

    <header class="text-center mb-5">
        <h1 class="display-4">We're Hiring: QA Engineer</h1>
        <p class="lead">Join our team to ensure the highest quality for our software solutions!</p>
    </header>

    <section class="mb-5">
        <h2>About the Role</h2>
        <p>
            We are looking for a detail-oriented <strong>QA Engineer</strong> to join our team.
            In this role, you will be responsible for testing our applications, identifying bugs, and ensuring
            that our software delivers an exceptional user experience.
        </p>
    </section>

    <section class="mb-5">
        <h2>Responsibilities</h2>
        <ul>
            <li>Develop, document, and execute test plans and test cases for software products.</li>
            <li>Perform manual and automated testing to identify bugs and ensure quality.</li>
            <li>Collaborate with developers to understand requirements and troubleshoot issues.</li>
            <li>Ensure software meets business and user requirements before release.</li>
            <li>Monitor and track quality metrics to improve testing processes.</li>
            <li>Provide clear documentation of bugs, test results, and quality reports.</li>
            <li>Stay updated on the latest testing tools and industry best practices.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Qualifications</h2>
        <ul>
            <li>Proven experience as a QA Engineer or similar role.</li>
            <li>Proficiency in manual testing and familiarity with automated testing tools like Selenium, Cypress, or TestNG.</li>
            <li>Strong understanding of software development lifecycles (SDLC) and testing methodologies.</li>
            <li>Experience with bug tracking tools such as Jira or Bugzilla.</li>
            <li>Knowledge of programming or scripting languages (e.g., Java, Python) is a plus.</li>
            <li>Excellent problem-solving skills and attention to detail.</li>
            <li>Strong communication and collaboration skills.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Nice-to-Haves</h2>
        <ul>
            <li>Experience with performance testing tools like JMeter.</li>
            <li>Knowledge of API testing using Postman or similar tools.</li>
            <li>Familiarity with continuous integration/continuous deployment (CI/CD) pipelines.</li>
        </ul>
    </section>

    <section class="mb-5">
        <h2>Benefits</h2>
        <ul>
            <li>Competitive salary and performance-based bonuses.</li>
            <li>Comprehensive health, dental, and vision insurance.</li>
            <li>Flexible working hours and remote work options.</li>
            <li>Opportunities for career growth and skill development.</li>
            <li>A supportive and collaborative work environment.</li>
        </ul>
    </section>
    <!--
        <section class="text-center">
            <h2>How to Apply</h2>
            <p>
                If you’re passionate about quality and testing, we’d love to hear from you!
                Send your resume and a brief cover letter to
                <a href="mailto:careers@yourcompany.com">careers@yourcompany.com</a>.
            </p>
            <a href="mailto:careers@yourcompany.com" class="btn btn-primary btn-lg">Apply Now</a>
        </section>
        -->
</div>
